export default __webpack_public_path__ + "static/media/artist-img7.117eb650.jpg";